import React from 'react';
import ReactDOM from 'react-dom';
import Chat from './App';
import './index.css'


ReactDOM.render(
  React.createElement(Chat),
  document.getElementById('widget')
);
